import { CommitmentRanking } from './CommitmentRanking';

/**
 * Class representing a user commitment ranking.
 * @extends CommitmentRanking
 */
export class UserCommitmentRanking extends CommitmentRanking {}
